import { render, staticRenderFns } from "./reports2.vue?vue&type=template&id=61902f56&scoped=true&"
import script from "./reports2.vue?vue&type=script&lang=js&"
export * from "./reports2.vue?vue&type=script&lang=js&"
import style0 from "./reports2.vue?vue&type=style&index=0&id=61902f56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61902f56",
  null
  
)

export default component.exports